import * as user from './user'
import * as favorites from './favorites'
import * as orders from './orders'

export { user, favorites, orders }



// WEBPACK FOOTER //
// ./src/features/Personal/actions/index.js